/** Must match NTA PermissionCatalog and StaffPermissionCodes. */
export const HOTEL_PERMISSIONS = {
  dashboard: { view: 'hotel.dashboard.view' },
  requests: {
    view: 'hotel.requests.view',
    create: 'hotel.requests.create',
    update: 'hotel.requests.update',
    delete: 'hotel.requests.delete',
    assign: 'hotel.requests.assign',
    status: 'hotel.requests.status',
  },
  rooms: {
    view: 'hotel.rooms.view',
    create: 'hotel.rooms.create',
    update: 'hotel.rooms.update',
    delete: 'hotel.rooms.delete',
  },
  housekeeping: {
    view: 'hotel.housekeeping.view',
    taskManage: 'hotel.housekeeping.task-manage',
    taskStatus: 'hotel.housekeeping.task-status',
    taskAssign: 'hotel.housekeeping.task-assign',
    inspection: 'hotel.housekeeping.inspection',
    maintenanceManage: 'hotel.housekeeping.maintenance-manage',
  },
  roomTypes: {
    view: 'hotel.room-types.view',
    manage: 'hotel.room-types.manage',
  },
  availability: { view: 'hotel.availability.view' },
  calls: {
    view: 'hotel.calls.view',
    start: 'hotel.calls.start',
    receive: 'hotel.calls.receive',
    manage: 'hotel.calls.manage',
    departmentCall: 'hotel.calls.department-call',
    history: 'hotel.calls.history',
  },
  staff: {
    view: 'hotel.staff.view',
    create: 'hotel.staff.create',
    update: 'hotel.staff.update',
    delete: 'hotel.staff.delete',
    status: 'hotel.staff.status',
  },
  departments: {
    view: 'hotel.departments.view',
    create: 'hotel.departments.create',
    update: 'hotel.departments.update',
    toggle: 'hotel.departments.toggle',
    reorder: 'hotel.departments.reorder',
    assignStaff: 'hotel.departments.assign-staff',
  },
  bookings: {
    view: 'hotel.bookings.view',
    create: 'hotel.bookings.create',
    edit: 'hotel.bookings.edit',
    confirm: 'hotel.bookings.confirm',
    cancel: 'hotel.bookings.cancel',
    checkIn: 'hotel.bookings.check-in',
    paymentAdd: 'hotel.bookings.payment-add',
    reportsView: 'hotel.bookings.reports-view',
  },
  sessions: {
    view: 'hotel.sessions.view',
    create: 'hotel.sessions.create',
    update: 'hotel.sessions.update',
    delete: 'hotel.sessions.delete',
    checkout: 'hotel.sessions.checkout',
    qr: 'hotel.sessions.qr',
  },
  guestCrm: {
    view: 'hotel.guest-crm.view',
    manage: 'hotel.guest-crm.manage',
    reportsView: 'hotel.guest-crm.reports-view',
  },
  bookers: {
    view: 'hotel.bookers.view',
    manage: 'hotel.bookers.manage',
    reportsView: 'hotel.bookers.reports-view',
  },
  knowYourGuest: {
    view: 'know-your-guest.view',
    manage: 'know-your-guest.manage',
    review: 'know-your-guest.review',
    auditView: 'know-your-guest.audit.view',
    reportsView: 'know-your-guest.reports.view',
  },
  billing: {
    view: 'hotel.billing.view',
    generate: 'hotel.billing.generate',
    issue: 'hotel.billing.issue',
    paymentAdd: 'hotel.billing.payment-add',
    paymentVoid: 'hotel.billing.payment-void',
    adjustmentAdd: 'hotel.billing.adjustment-add',
    email: 'hotel.billing.email',
    export: 'hotel.billing.export',
    reports: 'hotel.billing.reports',
    analyticsView: 'hotel.billing.analytics-view',
    auditView: 'hotel.billing.audit-view',
    ledgerView: 'hotel.billing.ledger-view',
    onlinePaymentInitiate: 'hotel.billing.online-payment-initiate',
  },
  accounting: { ledgerView: 'hotel.accounting.ledger-view' },
  nightAudit: {
    view: 'hotel.night-audit.view',
    execute: 'hotel.night-audit.execute',
    reportsView: 'hotel.night-audit.reports-view',
  },
  qr: {
    view: 'hotel.qr.view',
    create: 'hotel.qr.create',
    download: 'hotel.qr.download',
    print: 'hotel.qr.print',
  },
  amenities: {
    view: 'hotel.amenities.view',
    create: 'hotel.amenities.create',
    update: 'hotel.amenities.update',
    delete: 'hotel.amenities.delete',
  },
  recommendations: {
    view: 'hotel.recommendations.view',
    create: 'hotel.recommendations.create',
    update: 'hotel.recommendations.update',
    delete: 'hotel.recommendations.delete',
  },
  pos: {
    orders: {
      view: 'hotel.pos.orders.view',
      create: 'hotel.pos.orders.create',
      update: 'hotel.pos.orders.update',
      delete: 'hotel.pos.orders.delete',
    },
    menu: {
      view: 'hotel.pos.menu.view',
      create: 'hotel.pos.menu.create',
      update: 'hotel.pos.menu.update',
      delete: 'hotel.pos.menu.delete',
    },
    clients: {
      view: 'hotel.pos.clients.view',
      create: 'hotel.pos.clients.create',
      update: 'hotel.pos.clients.update',
      delete: 'hotel.pos.clients.delete',
    },
    dashboard: {
      view: 'hotel.pos.dashboard.view',
    },
  },
  feedback: {
    view: 'hotel.feedback.view',
    update: 'hotel.feedback.update',
    delete: 'hotel.feedback.delete',
  },
  nightAudit: {
    view: 'hotel.night-audit.view',
    execute: 'hotel.night-audit.execute',
    reportsView: 'hotel.night-audit.reports-view',
  },
  settings: {
    view: 'hotel.settings.view',
    update: 'hotel.settings.update',
  },
  users: {
    view: 'hotel.users.view',
    create: 'hotel.users.create',
    update: 'hotel.users.update',
    delete: 'hotel.users.delete',
    resetPassword: 'hotel.users.reset-password',
  },
  roles: {
    view: 'hotel.roles.view',
    create: 'hotel.roles.create',
    update: 'hotel.roles.update',
    delete: 'hotel.roles.delete',
    permissions: 'hotel.roles.permissions',
  },
};

export const hasHotelPermission = (hasPermission, permission) =>
  typeof hasPermission === 'function' ? hasPermission(permission) : false;
